import { SetVmwareIntegratorWebComponent } from './component/SetVmwareIntegratorWebComponent';

export { SetVmwareIntegratorWebComponent };
